import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Velox AI - Ambient Revenue Intelligence Platform",
  description = "Transform deal chaos into clarity with RADAR, COMPASS, WIZARD, and Agent V. AI-powered revenue operations intelligence that moves at the speed of your buyers.",
  image = "/social-card.png",
  url = "https://velox-ai.com/",
  type = "website"
}) => {
  const fullTitle = title.includes('Velox AI') ? title : `${title} | Velox AI`;
  const fullUrl = url.startsWith('http') ? url : `https://velox-ai.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://velox-ai.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Velox AI" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* LinkedIn */}
      <meta property="linkedin:owner" content="Velox AI" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEOHead;